import { Page } from '@/types'
import React from 'react'
import { Learn } from '@/features'

type ILessonContext = {
  inSwipe: React.MutableRefObject<boolean>
  pages?: Page[]
  origin: Learn.T.LessonOrigin
  pagesLength: number
  lastIndex: number
  initialPage: number
}

export const LessonContext = React.createContext({} as ILessonContext)

type ProviderProps = React.PropsWithChildren<{
  initialPage?: number
  origin?: Learn.T.LessonOrigin
}>

export const LessonContextProvider = (props: ProviderProps) => {
  const { children, initialPage, origin = 'learn' } = props

  const _pages = Learn.S.lesson.use(s => s.pages)

  Learn.onPreloadImages(_pages)

  const inSwipe = React.useRef(false)

  const pages = React.useMemo(() => {
    if (!_pages?.length) return []
    return [...(origin === 'feed' ? [] : [{ id: 'start' } as Page]), ..._pages]
  }, [_pages, origin])

  const pagesLength = pages.length
  const lastIndex = pagesLength - 1

  const value: ILessonContext = {
    inSwipe,
    pages,
    origin,
    pagesLength,
    lastIndex,
    initialPage
  }

  return <LessonContext.Provider value={value}>{children}</LessonContext.Provider>
}

export function useLessonContext() {
  const context = React.useContext(LessonContext)
  if (!context) {
    throw new Error('useLessonContext must be used inside LearnProvider')
  }
  return context
}
